import { TabPanel } from "@material-ui/lab";
import { Editor } from "primereact/editor";
import { TabView } from "primereact/tabview";
import React from "react";
import { Table } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import { formatDate } from "../../../../../utils/utils";

function RecInvoiceBasicInfo({ invoice }) {
  return (
    <React.Fragment>
      <TabView className="tabview" scrollable>
        <TabPanel header="Invoice Main" rightIcon="fas fa-th-large">
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <CustomOutlinedDisabledTextField
                label="Customer Name"
                value={invoice.customer.customerName}
              />
              <CustomOutlinedDisabledTextField
                label="Currency"
                value={invoice.currency.currencyCode}
              />
              <CustomOutlinedDisabledTextField
                label="Document Reference"
                value={invoice.docRefDesc}
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <div className="row">
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Start Date"
                    value={formatDate(invoice.recStartDate)}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Issue Date"
                    value={formatDate(invoice.recIssueDate)}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Deadline Date"
                    value={formatDate(invoice.recDeadlineDate)}
                  />
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <CustomOutlinedDisabledTextField
                    label="Recurring Every"
                    value={invoice.recEvery}
                  />
                  <CustomOutlinedDisabledTextField
                    label="Period Type"
                    value={invoice.periodTypeDesc}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="card">
                <Table striped borderless hover size="sm" responsive="xl">
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th>Quantity</th>
                      <th>Unit Price</th>
                      <th>Item Discount</th>
                      <th>Tax</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.invoiceItem.map((item, index) => (
                      <tr key={index}>
                        <td>{item.itemName}</td>
                        <td>{item.qty}</td>
                        <td>
                          <NumberFormat
                            value={item.unitPrice}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            renderText={(value) => (
                              <div className="float-right">{value}</div>
                            )}
                          />
                        </td>
                        <td>
                          <NumberFormat
                            value={item.discountAmount}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            renderText={(value) => (
                              <div className="float-right">{value}</div>
                            )}
                          />
                        </td>
                        <td>
                          <NumberFormat
                            value={item.taxAmount}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            renderText={(value) => (
                              <div className="float-right">{value}</div>
                            )}
                          />
                        </td>
                        <td>
                          <NumberFormat
                            value={item.totalPrice}
                            displayType={"text"}
                            thousandSeparator={true}
                            decimalScale={2}
                            renderText={(value) => (
                              <div className="float-right">{value}</div>
                            )}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <th>Sub Total</th>
                      <td>
                        <NumberFormat
                          value={invoice.subTotal}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          renderText={(value) => (
                            <div className="float-right">{value}</div>
                          )}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <th>Discount Amount</th>
                      <td>
                        <NumberFormat
                          value={invoice.discountAmount}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          renderText={(value) => (
                            <div className="float-right">{value}</div>
                          )}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <th>Tax Amount</th>
                      <td>
                        <NumberFormat
                          value={invoice.taxAmount}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          renderText={(value) => (
                            <div className="float-right">{value}</div>
                          )}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <th>Grand Total</th>
                      <td>
                        <NumberFormat
                          value={invoice.grandTotal}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalScale={2}
                          renderText={(value) => (
                            <div className="float-right">{value}</div>
                          )}
                        />
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </div>
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Addresses" rightIcon="fas fa-map-marked-alt">
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <h3>Address</h3>
              <table className="table">
                <tbody>
                  <tr>
                    <th>Address</th>
                    <th>:</th>
                    <td>{invoice.address}</td>
                  </tr>
                  <tr>
                    <th>City</th>
                    <th>:</th>
                    <td>{invoice.city}</td>
                  </tr>
                  <tr>
                    <th>Postal Code</th>
                    <th>:</th>
                    <td>{invoice.postalCode}</td>
                  </tr>
                  <tr>
                    <th>Province</th>
                    <th>:</th>
                    <td>{invoice.province}</td>
                  </tr>
                  <tr>
                    <th>Phone Number</th>
                    <th>:</th>
                    <td>{invoice.addressPhone}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <th>:</th>
                    <td>{invoice.addressEmail}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <h3>Contact</h3>
              <table className="table">
                <tbody>
                  <tr>
                    <th>Contact Name</th>
                    <th>:</th>
                    <td>{invoice.contactName}</td>
                  </tr>
                  <tr>
                    <th>Position</th>
                    <th>:</th>
                    <td>{invoice.position}</td>
                  </tr>
                  <tr>
                    <th>Phone Number</th>
                    <th>:</th>
                    <td>{invoice.contactPhone}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <th>:</th>
                    <td>{invoice.contactEmail}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </TabPanel>

        <TabPanel header="Note" rightIcon="fas fa-th-large">
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6">
              <Editor
                readOnly={true}
                headerTemplate={
                  <span className="ql-formats">
                    <strong>Note</strong>
                  </span>
                }
                style={{ height: "200px", width: "100%" }}
                value={invoice.note}
              />
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6">
              <Editor
                readOnly={true}
                headerTemplate={
                  <span className="ql-formats">
                    <strong>Terms & Conditions</strong>
                  </span>
                }
                style={{ height: "200px", width: "100%" }}
                value={invoice.toc}
              />
            </div>
          </div>
        </TabPanel>
      </TabView>
    </React.Fragment>
  );
}

export default RecInvoiceBasicInfo;
